module.exports = {
  blogPostDir: "sample-posts", // The name of directory that contains your posts.
  siteTitle: "Terribly Sorry Studios", // Site title.
  siteTitleAlt: "Terribly Sorry Studios - Toronto Game Studio", // Alternative site title for SEO.
  siteLogo: "/android-chrome-512x512.png", // Logo used for SEO and manifest.
  siteUrl: "https://sorrystudios.com", // Domain of your website without pathPrefix.
  pathPrefix: "/", // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
  blogPath: "/blog",
  siteDescription: "Terribly Sorry Studios is a Canadian collaborative game studio founded in 2015. We're here to make fun games and chew gum, and we're all outta gum.", // Website description used for RSS feeds/meta description tag.
  siteRss: "/rss.xml", // Path to the RSS file.
  // TODO siteFBAppID: "1825356251115265", // FB Application ID for using app insights
  googleAnalyticsID: "UA-96339473-4", // GA tracking ID.
  // TODO disqusShortname: "https-vagr9k-github-io-gatsby-advanced-starter", // Disqus shortname.
  postDefaultCategoryID: "Games", // Default category for posts.
  userName: "Terribly Sorry Studios", // Username to display in the author segment.
  userTwitter: "sorrystudios", // Optionally renders "Follow Me" in the UserInfo segment.
  userLocation: "Toronto, Canada", // User location to display in the author segment.
  // TODO userAvatar: "https://api.adorable.io/avatars/150/test.png", // User avatar to display in the author segment.
  userDescription:
    "Terribly Sorry Studios is a Canadian collaborative game studio founded in 2015. We're here to make fun games and chew gum, and we're all outta gum.", // User description to display in the author segment.
  // Links to social profiles/projects you want to display in the author segment/navigation bar.
  userLinks: [
    {
      label: "Twitter",
      url: "https://twitter.com/sorrystudios",
      iconClassName: "fa fa-twitter"
    },
    {
      label: "Email",
      url: "mailto:info@sorrystudios.com",
      iconClassName: "fa fa-envelope"
    }
  ],
  copyright: "© 2018 Terribly Sorry Studios", // Copyright string for the footer of the website and RSS feed.
  themeColor: "#5e0051", // Used for setting manifest and progress theme colors.
  backgroundColor: "#ffffff" // Used for setting manifest background color.
};



// WEBPACK FOOTER //
// ./data/SiteConfig.js